import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@occc/ui-design-system';
import { displayAmount } from '@occc-app/lib/currency';
import { ActivateTransactionFragment } from '@occc/graphql';

import { ORDER_AHEAD_RECEIPT_MESSAGE } from './transaction-view.constants';
import { getIsOrderAheadTransaction } from './utils';

type TransactionViewFooterProps = {
  total: number;
  subTotal?: number;
  discount?: number;
  tax?: number;
  vendorName?: ActivateTransactionFragment['vendorName'];
};

export const TransactionViewFooter = (props: TransactionViewFooterProps) => {
  const { total, subTotal, discount, tax, vendorName } = props;
  const isOrderAheadTransaction = getIsOrderAheadTransaction(vendorName);

  return (
    <TableContainer
      sx={(theme) => ({
        marginBottom: theme.spacing(1),
      })}
    >
      <Table>
        <TableBody>
          {subTotal ? (
            <TableRow>
              <TableCell>Sub Total</TableCell>
              <TableCell align='right'>{displayAmount(subTotal, false)}</TableCell>
            </TableRow>
          ) : null}
          {discount ? (
            <TableRow>
              <TableCell>Total Discount</TableCell>
              <TableCell align='right'>—{displayAmount(Math.abs(discount), false)}</TableCell>
            </TableRow>
          ) : null}
          {tax ? (
            <TableRow>
              <TableCell>Tax</TableCell>
              <TableCell align='right'>{displayAmount(tax, false)}</TableCell>
            </TableRow>
          ) : null}
          <TableRow>
            <TableCell>
              <Typography fontWeight={700}>Total</Typography>
            </TableCell>
            <TableCell align='right'>
              {isOrderAheadTransaction ? (
                <Typography>{ORDER_AHEAD_RECEIPT_MESSAGE}</Typography>
              ) : (
                <Typography fontWeight={700}>{displayAmount(total, false)}</Typography>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
